export type AuthMode = 'platform' | 'merchant'

export const AUTH_SESSION_KEYS = ['accessToken', 'user', 'authMode'] as const
export type AuthSessionKey = (typeof AUTH_SESSION_KEYS)[number]

export function getAuthSessionItem(key: AuthSessionKey): string | null {
  if (typeof window === 'undefined') return null
  return sessionStorage.getItem(key)
}

export function setAuthSessionItem(key: AuthSessionKey, value: string): void {
  if (typeof window === 'undefined') return
  sessionStorage.setItem(key, value)
}

export function removeAuthSessionItem(key: AuthSessionKey): void {
  if (typeof window === 'undefined') return
  sessionStorage.removeItem(key)
}

export function getAccessToken(): string | null {
  return getAuthSessionItem('accessToken')
}

export function getAuthMode(): AuthMode | null {
  const mode = getAuthSessionItem('authMode')
  return mode === 'merchant' || mode === 'platform' ? mode : null
}

export function setAuthMode(mode: AuthMode): void {
  setAuthSessionItem('authMode', mode)
}

export function clearAllAuthStorage(): void {
  if (typeof window === 'undefined') return
  AUTH_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key))
  AUTH_SESSION_KEYS.forEach((key) => localStorage.removeItem(key))
}

export interface StoredUser {
  username: string
  name?: string
  id?: string
  roles?: string[]
}

export function getStoredUser(): StoredUser | null {
  const raw = getAuthSessionItem('user')
  if (!raw) return null
  try {
    return JSON.parse(raw) as StoredUser
  } catch {
    return null
  }
}

export function setStoredUser(user: StoredUser): void {
  setAuthSessionItem('user', JSON.stringify(user))
}
